import { arrayUnion, doc, updateDoc } from "firebase/firestore";

import { db } from "../firebase";

const saveFCMToken = async (uid: string, fcmToken: string) => {
  const userRef = doc(db, `users/${uid}`);
  await updateDoc(userRef, {
    fcmToken: arrayUnion(fcmToken),
  });
};

export default saveFCMToken;
